export const COMPANY_ANALYTICS = "company-analytics";
